module.exports = __webpack_public_path__ + "static/mystra-DND3_FnP-ef15e53c77d61380c11093c6e7b29b77.jpg";